import React, { useLayoutEffect, useRef } from "react";
import { useNmiScriptLoader } from "../hooks/useNmiScriptLoader";
import { getEmailConfig, validateEmail } from "../utils/emailUtils";
import { StorageManager } from "../utils/storageManager";

interface NmiScriptManagerProps {}

export const NmiScriptManager: React.FC<NmiScriptManagerProps> = () => {
  const { loadNmiScript } = useNmiScriptLoader();
  const lastEmailRef = useRef<string | null>(null);

  const checkEmailAndLoadScript = () => {
    try {
      const userData = StorageManager.getRxUserData();
      const email = userData?.email?.trim() || "";
      if (lastEmailRef.current === email) {
        return;
      }
      lastEmailRef.current = email;
      if (!validateEmail(email) && email !== "") {
        return;
      }

      const emailConfig = getEmailConfig(email);

      if (!emailConfig.apiKey) {
        return;
      }

      const scriptConfig = {
        apiKey: emailConfig.apiKey,
        scriptId: "nmiApiKey",
        scriptUrl: "https://secure.safewebservices.com/token/Collect.js",
      };

      loadNmiScript(scriptConfig);
    } catch (error) {
      console.error("[NmiScriptManager] Error checking email and loading script");
    }
  };

  useLayoutEffect(() => {
    checkEmailAndLoadScript();
  }, [loadNmiScript]);

  return null;
};
